<template>
  <div class="about">
    <iframe src="https://www.nextgenenvironment.ca/aurora-about716283" loading="eager" width="100%" style="border:none;height: 100vh;" class="ma-0 pa-0"></iframe>
  </div>
</template>
